/**
 * Labstep
 *
 * @module containers/Thumbnail
 */

import type { APICallOptions } from 'labstep-web/models';
import {
  thumbnailErrorAction,
  thumbnailFetchUrlAction,
} from 'labstep-web/state/actions/thumbnail';
import {
  selectThumbnailStatus,
  selectThumbnailUrl,
} from 'labstep-web/state/selectors/thumbnail';
import type { LabstepReduxState } from 'labstep-web/state/types';
import { connect } from 'react-redux';
import type { INewThumbnailContainerProps, OwnProps } from './types';

const Thumbnail = ({ children, ...rest }) => children(rest);

const mapStateToProps = (
  state: LabstepReduxState,
  ownProps: OwnProps,
) => ({
  src: selectThumbnailUrl(state, ownProps.fileGuid, ownProps.params),
  status: selectThumbnailStatus(
    state,
    ownProps.fileGuid,
    ownProps.params,
  ),
});

const mapDispatchToProps = (dispatch, ownProps: OwnProps) => ({
  fetchUrl(options = {} as APICallOptions) {
    dispatch(
      thumbnailFetchUrlAction(
        ownProps.fileGuid,
        ownProps.params,
        options,
      ),
    );
  },
  onError() {
    dispatch(
      thumbnailErrorAction(ownProps.fileGuid, ownProps.params, {}),
    );
  },
});

export const NewThumbnailContainer: React.FC<INewThumbnailContainerProps> =
  connect(mapStateToProps, mapDispatchToProps)(Thumbnail);
